// extracted by mini-css-extract-plugin
export default {"badge":"RaTwpe"};